import { produce } from 'immer'

// Action Types
export const SET_OUTBOUND_CONTACT_LISTS = 'outbound/setContactLists'
export const SET_OUTBOUND_CONTACT_LIST = 'outbound/setContactList'
export const SET_OUTBOUND_CONTACT_LISTS_LOADING = 'outbound/contactLists/setLoading'
export const SET_OUTBOUND_CONTACTS = 'outbound/setContacts'

// Action Creators
export const setContactLists = (payload) => ({
  type: SET_OUTBOUND_CONTACT_LISTS,
  payload,
})

export const setContactList = (payload) => ({
  type: SET_OUTBOUND_CONTACT_LIST,
  payload,
})

export const setContacts = (payload) => ({
  type: SET_OUTBOUND_CONTACTS,
  payload,
})

export const setLoading = (payload) => ({
  type: SET_OUTBOUND_CONTACT_LISTS_LOADING,
  payload,
})

// State
export const initialState = {
  data: {
    contactLists: [],
    contactList: null,
    contacts: [],
    contactsTotal: 0,
  },
  loading: {
    contactLists: false,
    contactList: false,
    contacts: false,
    csvExport: false,
  },
}

// Reducer
export default function outboundContactListsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_OUTBOUND_CONTACT_LISTS_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_OUTBOUND_CONTACT_LISTS:
        newState.data.contactLists = payload
        break
      case SET_OUTBOUND_CONTACT_LIST:
        newState.data.contactList = payload
        break
      case SET_OUTBOUND_CONTACTS:
        newState.data.contacts = payload.contacts
        newState.data.contactsTotal = payload.total
        break
      default:
        break
    }
  })
}
